import { Button, Modal, ModalBody, ModalFooter, ModalHeader, SpinningButton, ModalProps, ModalLoading } from "Components/ReactstrapSlim";
import { DeclineRequest, HourlyRequestsClient, HourlyRequestToBookStatus, ReservationRequestDetailsModel } from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import { LayoutContext } from "Components/LayoutContext";
import React, { useContext, useEffect, useState } from "react";
import { formatReservationTime } from "Utils/datetime";
import moment from "moment";

interface HourlyRequestToBookCancelModalProps extends ModalProps {
   requestId: Guid,
   toggle: () => void,
   onSuccess?: () => void,
}

const HourlyRequestToBookCancelByOwnerModal: React.FC<HourlyRequestToBookCancelModalProps> = ({ requestId, toggle, onSuccess, ...modalProps }) => {
   const layoutContext = useContext(LayoutContext);
   const [isSaving, setIsSaving] = useState<boolean>(false);
   const [isLoading, setIsLoading] = useState<boolean>(false);
   const [request, setRequest] = useState<ReservationRequestDetailsModel | undefined>(undefined);

   const hourlyRequestToBookClient = useApiClient(HourlyRequestsClient);

   const cancelRequest = async () => {
      setIsSaving(true);
      try {
         await hourlyRequestToBookClient.decline(requestId, new DeclineRequest({
            liquidSpaceCost: undefined,
            message: undefined
         }));
         if (onSuccess)
            onSuccess();
         toggle();
      }
      catch (ex) {
         layoutContext.showError(ex);
      }
      finally {
         setIsSaving(false);
      }
   }

   const toggleAlreadyCancelledModal = () => {
      if (onSuccess)
         onSuccess();
      toggle();
   }

   const getRequestInfo = async (signal: AbortSignal) => {
      setIsLoading(true)
      try {
         setRequest(await hourlyRequestToBookClient.hourlyRequestReservationDetails(requestId, signal));
      }
      catch (ex) {
         if (!signal.aborted)
            layoutContext.showError(ex);
      }
      finally {
         setIsLoading(false);
      }
   }

   useEffect(() => {
      const abort = new AbortController();
      getRequestInfo(abort.signal);
      return function cancel() {
         abort.abort();
      }
   }, []);



   return (isLoading ? <ModalLoading />
      : request
         ? request.status != HourlyRequestToBookStatus.Pending && request.status != HourlyRequestToBookStatus.Paused
            ? <Modal isOpen={modalProps.isOpen} toggle={toggleAlreadyCancelledModal} centered>
               <ModalBody className='mt-px56'>
                  {`Reservation request for ${request.workspaceName} at ${request.venueName} on ${`${moment(request.startTime).format("dddd, MMM DD")}, ${formatReservationTime(request.startTime, request.endTime)}`}`}
                  {request?.status == HourlyRequestToBookStatus.Approved
                     ? " has been already approved by the host."
                     : ` was cancelled${(request?.status == HourlyRequestToBookStatus.CancelledByHost ? " by the host" : "")}.`}
               </ModalBody>
               <ModalFooter>
                  <Button type="button" color="primary" onClick={toggleAlreadyCancelledModal}>Ok</Button>
               </ModalFooter>
            </Modal>
            : <Modal {...modalProps} toggle={toggle}>
               <ModalHeader toggle={toggle}>Cancel Request</ModalHeader>
               <ModalBody>
                  Are you sure you want to cancel reservation request for {request.workspaceName} at {request.venueName} on {`${moment(request.startTime).format("dddd, MMM DD")}, ${formatReservationTime(request.startTime, request.endTime)}`}?
               </ModalBody>
               <ModalFooter>
                  <Button type="button" color="secondary" onClick={toggle}>No</Button>
                  <SpinningButton type="button" color="primary" onClick={() => cancelRequest()} isLoading={isSaving}>Yes</SpinningButton>
               </ModalFooter>
            </Modal>
         : null)
}

export default HourlyRequestToBookCancelByOwnerModal